// Cabin & Cargo - minimal behaviour only.
(function () {
  'use strict';

  // Product gallery: swap the main image when a thumbnail is chosen.
  var main = document.querySelector('[data-main-image]');
  if (main) {
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) {
          main.src = full;
          main.srcset = '';
        }
      });
    });
  }

  // Option pickers. Each control sets one option; the matching variant is
  // found by comparing the whole selection, so it works for any number of
  // options rather than assuming colour and size.
  var optionsRoot = document.querySelector('[data-options]');
  var variantData = document.querySelector('[data-variant-data]');

  if (optionsRoot && variantData) {
    var variants = [];
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (e) {
      variants = [];
    }

    var idField = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var addButton = document.querySelector('[data-add]');

    function currentSelection() {
      var chosen = [];
      optionsRoot.querySelectorAll('.options__group').forEach(function (group, index) {
        var active = group.querySelector('.swatch.is-active');
        if (active) {
          chosen[index] = active.getAttribute('data-option-value');
          return;
        }
        var select = group.querySelector('.options__select');
        if (select) chosen[index] = select.value;
      });
      return chosen;
    }

    function matchVariant(chosen) {
      for (var i = 0; i < variants.length; i++) {
        var options = variants[i].options || [];
        var same = options.length === chosen.length;
        for (var j = 0; same && j < options.length; j++) {
          if (options[j] !== chosen[j]) same = false;
        }
        if (same) return variants[i];
      }
      return null;
    }

    function update() {
      var chosen = currentSelection();
      var variant = matchVariant(chosen);

      optionsRoot.querySelectorAll('[data-chosen-for]').forEach(function (el) {
        var index = parseInt(el.getAttribute('data-chosen-for'), 10);
        if (!isNaN(index) && chosen[index]) el.textContent = chosen[index];
      });

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'Unavailable';
        }
        return;
      }

      if (idField) idField.value = variant.id;
      if (priceEl && variant.priceText) priceEl.textContent = variant.priceText;

      // Show the picture for the chosen colour. Nothing happens when the
      // variant has no image of its own, which is better than blanking the
      // gallery or flashing back to the default.
      var main = document.querySelector('[data-main-image]');
      if (main && variant.image && main.getAttribute('src') !== variant.image) {
        main.src = variant.image;
        main.srcset = '';
        if (variant.imageAlt) main.alt = variant.imageAlt;
        var thumbs = document.querySelectorAll('[data-thumb]');
        thumbs.forEach(function (thumb) {
          var isCurrent = thumb.getAttribute('data-full') === variant.image;
          thumb.classList.toggle('is-current', isCurrent);
        });
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    optionsRoot.querySelectorAll('.swatch').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('.options__group');
        group.querySelectorAll('.swatch').forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        update();
      });
    });

    optionsRoot.querySelectorAll('.options__select').forEach(function (select) {
      select.addEventListener('change', update);
    });

    update();
  }

  // Reveal sections as they are scrolled to.
  var revealables = document.querySelectorAll(
    '[data-reveal], [data-reveal-media], [data-reveal-stagger]');

  if (revealables.length) {
    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      // No observer, or motion is unwanted: show everything immediately.
      revealables.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          watcher.unobserve(entry.target);   // reveal once, then leave it alone
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

      revealables.forEach(function (el) { watcher.observe(el); });

      // Anything already on screen at load should not wait for a scroll.
      window.setTimeout(function () {
        revealables.forEach(function (el) {
          var box = el.getBoundingClientRect();
          if (box.top < window.innerHeight && box.bottom > 0) {
            el.classList.add('is-in');
          }
        });
      }, 60);
    }
  }

  // Cart quantity changes submit without hunting for an update button.
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
